export const UPCOMING_MULTIFACTOR_FACTORS = [
  {
    title: 'Security key',
    description:
      'Require the user to use a physical security key such as Yubikey',
  },
];
